import I18n from 'I18n';
import { DATE, DATE_TIME, NUMBER } from 'customer-data-objects/property/PropertyTypes';
import { getPropertyLabel } from 'customer-data-property-utils/PropertyDisplay';
import { isVisibleGridProperty
// @ts-expect-error untyped
} from 'crm_data/properties/GridProperties';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import set from 'transmute/set';
import { RECURRING_REVENUE_AMOUNT_PROPERTIES } from '../constants/ForecastType';
import { DEAL_PROPERTY_NAMES } from '../constants/properties';
export const getPropertyDisplayName = (properties, property) => {
  if (!property) {
    return '';
  }
  if (properties && properties[property]) {
    return properties[property].label;
  }
  return property;
};
const sortPropertyOptions = options => {
  return options.sort((a, b) => a.text.localeCompare(b.text));
};
const AMOUNT_PROPERTIES_TO_EXCLUDE = ['hs_projected_amount', 'hs_projected_amount_in_home_currency', 'amount_in_home_currency', 'hs_forecast_amount'];
export const getPropertyOptionsForForecastWizard = dealProperties => {
  const hubspotDateProperties = [];
  const customDateProperties = [];
  const hubspotAmountProperties = [];
  const customAmountProperties = [];
  dealProperties.forEach(property => {
    const option = {
      text: property.label,
      value: property.name,
      help: RECURRING_REVENUE_AMOUNT_PROPERTIES.includes(property.name) ? I18n.text('createForecastTypeWizard.stepOne.recurringRevenueDescription') : null
    };
    if ((property.type === DATE_TIME || property.type === DATE) && !property.deleted && !property.hidden) {
      if (property.hubspotDefined) {
        hubspotDateProperties.push(option);
      } else {
        customDateProperties.push(option);
      }
    } else if (property.type === NUMBER && property.showCurrencySymbol && !property.deleted && !property.hidden && !AMOUNT_PROPERTIES_TO_EXCLUDE.includes(property.name)) {
      if (property.hubspotDefined) {
        hubspotAmountProperties.push(option);
      } else {
        customAmountProperties.push(option);
      }
    }
  });
  return {
    datePropertyOptions: [{
      text: I18n.text('createForecastTypeWizard.stepOne.hubSpotOwnedProperties'),
      options: sortPropertyOptions(hubspotDateProperties)
    }, {
      text: I18n.text('createForecastTypeWizard.stepOne.customProperties'),
      options: customDateProperties
    }],
    amountPropertyOptions: [{
      text: I18n.text('createForecastTypeWizard.stepOne.hubSpotOwnedProperties'),
      options: sortPropertyOptions(hubspotAmountProperties)
    }, {
      text: I18n.text('createForecastTypeWizard.stepOne.customProperties'),
      options: customAmountProperties
    }]
  };
};
const fromProperty = function fromProperty(options) {
  const {
    name,
    type,
    hidden,
    groupName
  } = options;
  return {
    text: getPropertyLabel(options),
    value: name,
    type,
    hidden,
    groupName
  };
};
const fromPropertyGroup = group => ({
  options: group.properties.map(fromProperty),
  text: group.hubspotDefined ? propertyLabelTranslator(group.displayName) : group.displayName,
  value: group.name
});
export const fromPropertyGroups = groups => groups.map(fromPropertyGroup);
export const getPropertyGroupsAsOptions = (propertyGroups, isWeightedOrTotalPortalConfig, hasDealTagsAccess) => {
  const propertyGroupsWithFilteredProperties = propertyGroups.map(propertyGroup => {
    const visibleProperties = propertyGroup.properties.filter(property => {
      if (property.name === DEAL_PROPERTY_NAMES.DEAL_TAGS) {
        return hasDealTagsAccess && isVisibleGridProperty(null, property);
      }

      // We filter our certain options based on the portal config
      if (isWeightedOrTotalPortalConfig) {
        return isVisibleGridProperty(null, property) && property.name !== DEAL_PROPERTY_NAMES.FORECAST_AMOUNT && property.name !== DEAL_PROPERTY_NAMES.FORECAST_PROBABILITY;
      }
      return isVisibleGridProperty(null, property);
    });
    return set('properties', visibleProperties, propertyGroup);
  });
  return fromPropertyGroups(propertyGroupsWithFilteredProperties);
};
export const haveSelectedColumnsBeenUpdated = (selectedColumns, savedColumns) => {
  if (!selectedColumns) {
    return false;
  }
  if (selectedColumns.length !== savedColumns.length) {
    return true;
  }
  return !selectedColumns.every((column, index) => column.value === savedColumns[index]);
};
export const getSelectedColumns = (columns, properties, selectedForecastTypeAmountProperty) => {
  const amountProperty = selectedForecastTypeAmountProperty !== null && selectedForecastTypeAmountProperty !== void 0 ? selectedForecastTypeAmountProperty : DEAL_PROPERTY_NAMES.AMOUNT;
  return columns.map(propertyName => {
    const property = properties[propertyName];
    const immovableColumns = [DEAL_PROPERTY_NAMES.DEAL_NAME, amountProperty];
    return {
      disabled: immovableColumns.includes(propertyName),
      readOnly: immovableColumns.includes(propertyName),
      text: getPropertyLabel(property),
      value: propertyName
    };
  }).filter(({
    text
  }) => !!text);
};